import { render, staticRenderFns } from "./successOrder.vue?vue&type=template&id=3744bffa&scoped=true"
import script from "./successOrder.vue?vue&type=script&lang=js"
export * from "./successOrder.vue?vue&type=script&lang=js"
import style0 from "./successOrder.vue?vue&type=style&index=0&id=3744bffa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3744bffa",
  null
  
)

export default component.exports